module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "6.c30b5d53.jpg";